import { createFileRoute } from "@tanstack/react-router"

import { JobRunsPage } from "@/pages/JobRunsPage"

export const Route = createFileRoute("/_admin/jobs")({
  component: JobRunsPage,
})
